import styled from 'styled-components'

export const StyledIntakeContainer = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: auto;
  padding: 0 4vw 2rem 4vw;

  .select-section {
    color: ${props => props.theme.fontColor};
    grid-row-gap: 0.8vw;
    display: grid;
    grid-template-columns: 1fr;
    font-size: 11pt;
  }

  .button-section {
    margin-top: 1rem;
    padding: 1rem 0;
    text-align: center;
  }

  .view-more {
    color: ${props => props.theme.fontColor};
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    font-size: 11pt;
    gap: 15px;
  }
`

export const ApplicationTypeOptionsRow = styled.div`
  display: grid;
  grid-template-columns: 3fr 5fr 2fr;

  span.name,
  span.select-label {
    justify-self: end;
    align-self: center;
    padding-right: 1vw;
    font-size: 10pt;
    font-weight: 600;
    color: ${props => props.theme.fontColor};
  }

  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr 2fr;
    margin-bottom: 10px;
  }

  @media only screen and (max-width: 600px) {
    grid-template-columns: ${({ view }: { view?: 'col' | 'row' }) => (view === 'row' ? '1fr 1fr' : '1fr')};

    span:first-child {
      justify-self: start;
      margin-bottom: 5px;
    }
  }
`

export const AccessCodeInput = styled.div`
  display: flex;
  gap: 10px;

  input {
    width: ${({ email }: { email?: boolean }) => (email ? '300px' : '200px')};
    line-height: 1.5em;
    padding: 0.5em 3.5em 0.5em 1em;
    appearance: none;
    background-color: white;
    border-radius: 2px;
    border: thin solid #c5c5c5;
    color: ${props => props.theme.fontColor};
    margin: 0;
    margin-bottom: 5px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .validation-icon {
    position: absolute;
    min-width: 27px;
    margin-left: ${({ email }: { email?: boolean }) => (email ? '262px' : '163px')};
    box-sizing: border-box;
    padding: 10px;
    text-align: right;
    font-size: 13pt;
  }

  .fa-check-circle {
    color: #089908;
  }

  .fa-times-circle {
    color: red;
  }
`

export const ErrorLabelWrapper = styled.div`
  grid-column-start: 2;
  margin-top: -7px;

  @media only screen and (max-width: 600px) {
    grid-column-start: 1;
  }
`

export const StyledAddCourses = styled.div`
  min-width: 600px;

  @media only screen and (max-width: 600px) {
    min-width: unset;
  }
`
